import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { SalesforcePreDefinedType, PreDefinedResponse } from "../../types/shared";

export type SalesforcePredefinedApiServiceType = {
    getSfPreDefinedColumns(type: SalesforcePreDefinedType, cacheToken: string): Promise<PreDefinedResponse>;
};

export const salesforcePredefinedApiService = (fetchService: IFetchService): SalesforcePredefinedApiServiceType => {
    return {
        getSfPreDefinedColumns: createCancelable(
            (signal: AbortSignal, type: SalesforcePreDefinedType, cacheToken: string): Promise<PreDefinedResponse> => {
                return fetchService.get(
                    `sales-api/salesforce/predefined-${type}-columns?cacheToken=${cacheToken}`,
                    undefined,
                    {
                        cancellation: signal,
                    },
                );
            },
        ),
    };
};
